import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfile.vue?vue&type=style&index=0&id=c7cd6cdc&lang=css"

const __exports__ = script;

export default __exports__